import {
  DAYS_TO_SHOW,
  TITLE,
} from "@/modules/timesheet/logs/views/week/constants";

import TimeSheetLogLayout from "@/modules/timesheet/logs/layout";
import { TimesheetHeaderTitle } from "@/modules/timesheet/components/header";
import TimesheetLogByDay from "@/modules/timesheet/logs/views/week/_Day_row";
import { getLastNDays } from "@/lib/utils";
import { useMemo } from "react";

export default function TimesheetLogWeek() {
  const dateKeys = useMemo(() => getLastNDays(DAYS_TO_SHOW), []);

  return (
    <TimeSheetLogLayout
      headerContent={<TimesheetHeaderTitle>{TITLE}</TimesheetHeaderTitle>}
    >
      {dateKeys.map((dateKey) => (
        <TimesheetLogByDay key={dateKey} date={dateKey} />
      ))}
    </TimeSheetLogLayout>
  );
}
